import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { icons } from 'src/app/Utility/assets';
import { ClientExtraData } from 'src/app/Interfaces/SQL-reports-responses';

@Component({
	selector: 'app-client-extra-data',
	templateUrl: './client-extra-data.component.html',
	styleUrls: ['./client-extra-data.component.scss'],
})
export class ClientExtraDataComponent {
	private router = inject(Router);
	constructor(@Inject(MAT_DIALOG_DATA) public data: ClientExtraData[]) {}

	// ngOnInit(): void {
	// }

	navigateInternally(url: string): void {
		this.router.navigate([url]);
	}

	navigateExternally(url: string): void {
		window.open(url, '_blank');
	}

	shouldNavigate(line: ClientExtraData): void {
		if (line.InternalUrl) {
			this.navigateInternally(line.InternalUrl);
			return;
		}
		if (line.IfUrl) {
			this.navigateExternally(line.IfUrl);
			return;
		}
	}

	isClickable(line: ClientExtraData): boolean {
		return !!line.InternalUrl || !!line.IfUrl;
	}
}
